import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    paddingTop: theme.mixins.toolbar.minHeight,
  },
}))

export default styles
